import { Button } from '@/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Mail } from 'lucide-react'

interface ForgotPasswordSentSearch {
  email: string | undefined
}

export const Route = createFileRoute('/_login_forms/_forgot_password/forgot-password-sent')({
  validateSearch: (search: Record<string, unknown>): ForgotPasswordSentSearch => ({
    email: search['email'] as string | undefined, // eslint-disable-line dot-notation
  }),
  beforeLoad: () => ({
    title: 'Check your email',
    description: 'We sent you a password reset link',
  }),
  component: ForgotPasswordSentPage,
})

function ForgotPasswordSentPage() {
  const { email } = Route.useSearch()

  return (
    <div className="space-y-6 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
        <Mail className="h-6 w-6 text-primary" />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">Check your email</h3>
        {email && (
          <p className="text-sm text-muted-foreground">
            We sent a password reset link to
            {' '}
            <span className="font-medium text-foreground">{email}</span>
          </p>
        )}
        <p className="text-sm text-muted-foreground">
          Click the link in the email to reset your password. The link expires in 10 minutes.
        </p>
      </div>
      <div className="space-y-2">
        <Button
          asChild
          variant="outline"
          className="w-full"
        >
          <Link to="/login">Back to login</Link>
        </Button>
        <p className="text-xs text-muted-foreground">
          Didn&apos;t receive the email? Check your spam folder or try again.
        </p>
      </div>
    </div>
  )
}
